import { useT } from "@/3-features/i18n/useT";
import { PATHS } from "@/3-features/navigation/routes";
import { Link } from "@/5-shared/routing";

/** Closing band. Single contact CTA. */
export function DualCTA({ title }: { title?: string }) {
  const { t } = useT();
  return (
    <section className="bg-zinc-950 text-white">
      <div className="shell py-40 text-center">
        <span className="eyebrow text-dec-green-light">{t("cta.eyebrow")}</span>
        <h2 className="section-title text-white max-w-2xl mx-auto">{title ?? t("cta.defaultTitle")}</h2>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to={PATHS.contact} className="btn btn-primary">
            {t("cta.contact")}
          </Link>
        </div>
      </div>
    </section>
  );
}
